export const GET_DOCUMENT_TYPES = "GET_DOCUMENT_TYPES"
export const GET_DOCUMENT_TYPES_FAIL = "GET_DOCUMENT_TYPES_FAIL"
export const GET_DOCUMENT_TYPES_SUCCESS = "GET_DOCUMENT_TYPES_SUCCESS"

export const ADD_NEW_DOCUMENT_TYPE = "ADD_NEW_DOCUMENT_TYPE"
export const ADD_DOCUMENT_TYPE_SUCCESS = "ADD_DOCUMENT_TYPE_SUCCESS"
export const ADD_DOCUMENT_TYPE_FAIL = "ADD_DOCUMENT_TYPE_FAIL"

export const UPDATE_DOCUMENT_TYPE = "UPDATE_DOCUMENT_TYPE"
export const UPDATE_DOCUMENT_TYPE_SUCCESS = "UPDATE_DOCUMENT_TYPE_SUCCESS"
export const UPDATE_DOCUMENT_TYPE_FAIL = "UPDATE_DOCUMENT_TYPE_FAIL"

export const DELETE_DOCUMENT_TYPE = "DELETE_DOCUMENT_TYPE"
export const DELETE_DOCUMENT_TYPE_SUCCESS = "DELETE_DOCUMENT_TYPE_SUCCESS"
export const DELETE_DOCUMENT_TYPE_FAIL = "DELETE_DOCUMENT_TYPE_FAIL"





